<ct-lib-modal
  #modal
  [medium]="true"
  [label]="
    'company-tool.snippets.sourcing-campaign-booking-modal.title' | transloco
  "
  [footer]="footer"
>
  <p class="modal-subheadline">
    {{
      'company-tool.snippets.sourcing-campaign-booking-modal.subheadline'
        | transloco
    }}
  </p>

  <ct-lib-radio-card-group
    class="mt-3"
    [value]="selectedMode()"
    (valueChange)="onModeChange($event)"
    orientation="vertical"
  >
    <ct-lib-radio-card
      [value]="SourcedJobsCampaignMode.LEADS"
      [icon]="fontawesomeService.light.users"
      [label]="
        'company-tool.snippets.sourcing-campaign-booking-modal.options.leads.title'
          | transloco
      "
      [sublabel]="
        'company-tool.snippets.sourcing-campaign-booking-modal.options.leads.credits'
          | transloco: { credits: CREDIT_COST_SOURCING_LEADS | number: '1.0-0' }
      "
      [description]="
        'company-tool.snippets.sourcing-campaign-booking-modal.options.leads.description'
          | transloco
      "
    />
    <ct-lib-radio-card
      [value]="SourcedJobsCampaignMode.AUTOPILOT"
      [icon]="fontawesomeService.light.sparkles"
      [label]="
        'company-tool.snippets.sourcing-campaign-booking-modal.options.autopilot.title'
          | transloco
      "
      [sublabel]="
        'company-tool.snippets.sourcing-campaign-booking-modal.options.autopilot.credits'
          | transloco
            : { credits: CREDIT_COST_SOURCING_AUTOPILOT | number: '1.0-0' }
      "
      [description]="
        'company-tool.snippets.sourcing-campaign-booking-modal.options.autopilot.description'
          | transloco
      "
    />
  </ct-lib-radio-card-group>
</ct-lib-modal>

<ng-template #footer>
  <app-button variant="white-grey" (click)="close()">
    {{
      'company-tool.snippets.sourcing-campaign-booking-modal.cancel' | transloco
    }}
  </app-button>
  <app-button
    variant="primary"
    [disabled]="!selectedMode()"
    [creditConsumptionAmount]="creditAmount()"
    [creditConsumptionClickCondition]="requiresCredits() && !!selectedMode()"
    (creditConsumptionClick)="onConfirm()"
  >
    {{
      'company-tool.snippets.sourcing-campaign-booking-modal.confirm'
        | transloco
    }}
  </app-button>
</ng-template>
